import type { SelectItemDefault } from '@consta/uikit/Select'
import { Select } from '@consta/uikit/Select'
import type { Nullable } from '@library/types'
import type { FC } from 'react'

import { SettingContainer } from './SettingContainer'

type Item = SelectItemDefault

type SettingSelectProps = {
  className?: string
  label: string
  errorText?: string
  value: Nullable<Item>
  items: Item[]
  placeholder?: string
  onChange: (value: Nullable<Item>) => void
}

export const SettingSelect: FC<SettingSelectProps> = ({
  onChange,
  label,
  value,
  items,
  errorText,
  className,
  placeholder,
}) => {
  return (
    <SettingContainer label={label}>
      <Select
        size="xs"
        className={className}
        caption={errorText}
        placeholder={placeholder}
        status={errorText !== undefined ? 'alert' : undefined}
        items={items}
        value={value}
        onChange={onChange}
      />
    </SettingContainer>
  )
}
